import type { ReleaseNotesResponse } from "@repo/shared/types";
import { get, post } from "./_client";

export function getReleaseNotes() {
  return get<ReleaseNotesResponse>("/internal/release-notes");
}

export function dismissReleaseNotes() {
  return post<{ success: boolean }>("/internal/release-notes/dismiss");
}
